export default __webpack_public_path__ + "static/media/divorceguidetop2.c3209160.png";